export interface adventureCharactersState {
  characters: Array<characterInterface>;
}
export interface characterInterface {
  id: string;
  name: string;
  archetype: string;
  hp: number;
  currentHp: number;
  mana: number;
  currentMana: number;
  mp: number;
  armorDvs: number;
  shieldDvs: number;
  moveDvs: number;
  bonusDvs: number;
  level: number;
  originSkill1: string;
  originSkill2: string;
  agility: number;
  charisma: number;
  health: number;
  intelligence: number;
  perception: number;
  power: number;
  strength: number;
  willpower: number;
  tempAgility: number;
  tempCharisma: number;
  tempHealth: number;
  tempIntelligence: number;
  tempPerception: number;
  tempPower: number;
  tempStrength: number;
  tempWillpower: number;
  exceptionalAgility: number;
  exceptionalCharisma: number;
  exceptionalHealth: number;
  exceptionalIntelligence: number;
  exceptionalPerception: number;
  exceptionalPower: number;
  exceptionalStrength: number;
  exceptionalWillpower: number;
  tempExceptionalAgility: number;
  tempExceptionalCharisma: number;
  tempExceptionalHealth: number;
  tempExceptionalIntelligence: number;
  tempExceptionalPerception: number;
  tempExceptionalPower: number;
  tempExceptionalStrength: number;
  tempExceptionalWillpower: number;
}

export default {
  namespaced: true,
  state: (): adventureCharactersState => ({
    characters: [],
  }),
  getters: {
    characters: (state: adventureCharactersState) => {
      return state.characters;
    },
  },
  mutations: {
    clearCharacters: (state: adventureCharactersState) => {
      state.characters = [];
    },
    addCharacterToAdventure: (
      state: adventureCharactersState,
      newData: characterInterface
    ) => {
      let alreadyIn = false;
      for (const character of state.characters) {
        if (newData.id === character.id) {
          alreadyIn = true;
        }
      }
      if (!alreadyIn) {
        state.characters.push(newData);
      }
    },
  },
  removeCharacterFromAdventure: (
    state: adventureCharactersState,
    newData: string
  ) => {
    for (let i = 0; i < state.characters.length; i++) {
      if (state.characters[i].id === newData) {
        state.characters.splice(i, 1);
      }
    }
  },
  editCharacterInAdventure: (
    state: adventureCharactersState,
    newData: characterInterface
  ) => {
    for (let i = 0; i < state.characters.length; i++) {
      if (state.characters[i].id === newData.id) {
        state.characters.splice(i, 1, newData);
      }
    }
  },
};
